<template>
  <div id="v-dashboard-frame">
    <header class="ob-header">
      <div class="ob-header-heading">
        <h5>Dashboard</h5>
        <h2>{{title}}</h2>
      </div>
      <div class="ob-header-profile">
        <div class="ob-header-profile-head">
          <b style="font-weight: 600;">{{$store.getters.user.fullname}}</b><br>
          <span style="font-size: 0.8em; color: #929292;">@{{$store.getters.user.handle}}</span>
        </div>
        <img class="ob-header-profile-img" v-bind:src="$store.getters.user.userProfileImg"/>
      </div>
    </header>
    <div id="d-dashboard-menu">
      <!-- NOT THE FULL DASHBOARD YET -->
      <!--<div class="d-dashboard-menu-left d-dashboard-menu-nav">
        <div>Recent Feed</div>
        <div>Following</div>
        <div>Services</div>
      </div>
      <div class="d-dashboard-menu-right d-dashboard-menu-nav">
        <div>Your Collectives</div>
      </div>-->
      <div class="d-dashboard-menu-left d-dashboard-menu-nav" @click="changeMode('collectives')">
        <div v-bind:class="{active: mode === 'collectives'}">Your Collectives</div>
      </div>
      <div class="d-dashboard-menu-right d-dashboard-menu-nav" @click="changeMode('services')">
        <div v-bind:class="{active: mode === 'services'}">Services</div>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in">
      <div class="c-loading" style="margin-top: 40px; margin-bottom: 40px;" v-if="loading"></div>
      <div class="d-dashboard-menu-view" v-if="mode === 'collectives' && !loading" key="collectives">
        <div v-if="Object.keys(userCollectives).length" style="margin-top: 20px;">
          <div v-for="collective in userCollectives" :key="collective.handle" class="dashboard-collective" @click="goToCollective(collective.handle)">
            <b>{{collective.fullname}}</b> <span>(@{{collective.handle}})</span>
            <br>
            <span style="font-size: 12px;">
              {{(collective.images ? Object.keys(collective.images).length : 0)}} images | {{Object.keys(collective.members).length}} members
            </span>
          </div>
          <button to="/onboarding" style="margin: 20px 0;" @click="goToOnboarding()">Create/Join Collective</button>
        </div>
        <div v-else>
          <h1 class="h-thin" style="font-size: 2em;">Welcome to Prism</h1>
          <p style="max-width: 500px; margin: 0 auto; line-height: 1.5;">It doesn't seem like you are a part of a collective yet. Would you like to <router-link to="/onboarding">create or join one?</router-link></p>
        </div>
      </div>
      <div class="d-dashboard-menu-view" v-if="mode === 'services' && !loading" key="services">
        <h1 class="h-thin" style="font-size: 2em;">Here are your past &amp; coming services</h1>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      mode: 'collectives',
      loading: true
    }
  },
  methods: {
    changeMode (mode) {
      if (this.mode !== mode) {
        this.mode = mode
        this.loading = false
      }
    },
    goToCollective (handle) {
      this.$router.push('/admin/' + handle + '/d')
    },
    goToOnboarding () {
      this.$router.push('/onboarding')
    }
  },
  computed: {
    title () {
      if (this.mode === 'services') {
        return 'Services'
      } else {
        return 'Your Collectives'
      }
    },
    userCollectives () {
      return this.$store.state.userCollectives
    }
  },
  created: function () {
    this.$firebase.auth().onAuthStateChanged((user) => {
      this.$store.dispatch('fetchUserCollectives').then(() => {
        this.loading = false
      })
    })
  }
}
</script>
<style lang="scss">
  .ob-header {
    padding: 40px 20px;
    padding-bottom: 60px;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ob-header-heading {
    text-align: left;
    h2 {
      font-size: 2em;
      margin: 5px 0;
      font-weight: 600;
    }
    h5 {
      font-size: 1em;
      font-weight: 400;
      color: #666;
      margin: 5px 0;
    }
  }
  .ob-header-profile {
    text-align: right;
  }
  #d-dashboard-menu {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 1080px;
  }
  .d-dashboard-menu-nav {
    div {
      display: inline-block;
      margin: 5px 10px;
      text-align: center;
      font-weight: 500;
      color: #A1A1A1;
      cursor: pointer;

      &:hover {
        color: #808080;
      }

      &.active {
        color: #5F5F5F;
        font-weight: 600;
      }
    }
  }

  .dashboard-collective {
    margin: 10px auto;
    padding: 15px 20px;
    background-color: #EFEFEF;
    border-radius: 4px;
    max-width: 960px;
    text-align: left;
    cursor: pointer;
    transition: 150ms ease;

    &:hover {
      background-color: #EAEAEA;
      transition: 150ms ease;
    }

    &:active {
      background-color: #E0E0E0;
      transition: 50ms ease;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/Dashboard/DashboardFrame.vue